"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormLabel = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _FormLabel = require("./FormLabel.styled");
var _excluded = ["label", "className", "labelFor", "required", "hidden", "useAs"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var FormLabel = exports.FormLabel = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var label = _ref.label,
    className = _ref.className,
    labelFor = _ref.labelFor,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$hidden = _ref.hidden,
    hidden = _ref$hidden === void 0 ? false : _ref$hidden,
    _ref$useAs = _ref.useAs,
    useAs = _ref$useAs === void 0 ? 'label' : _ref$useAs,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var LabelMarkup = {
    label: /*#__PURE__*/_react["default"].createElement(_FormLabel.StyledLabel, (0, _extends2["default"])({
      className: "".concat(className, " text-secondary"),
      htmlFor: labelFor,
      hidden: hidden
    }, props), label),
    span: /*#__PURE__*/_react["default"].createElement(_FormLabel.StyledSpan, (0, _extends2["default"])({
      className: "".concat(className, " text-secondary"),
      htmlFor: labelFor,
      hidden: hidden
    }, props), label)
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, required && /*#__PURE__*/_react["default"].createElement(_FormLabel.StyledAsterisk, {
    "data-testid": "required-asterisk",
    className: "text-danger",
    icon: _freeSolidSvgIcons.faAsterisk
  }), LabelMarkup[useAs]);
});
FormLabel.propTypes = {
  label: _propTypes["default"].string,
  className: _propTypes["default"].string,
  labelFor: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  hidden: _propTypes["default"].bool,
  useAs: _propTypes["default"].oneOf(['label', 'span'])
};